import { VIcon } from 'vuetify/lib/components/VIcon';
import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isMobile
    ? _c("div", [
        _vm.lpuAddress.show_phone && _vm.lpuAddress.lpu.lpuphone?.phone
          ? _c(
              "a",
              {
                directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                staticClass:
                  "d-flex align-center text-decoration-none text-body-1 primary--text py-2 mt-2",
                attrs: {
                  "data-qa": "lpu_card_btn_phone",
                  "data-ya-goals-appointment":
                    "mobile_appointment__phone_action",
                  "data-google-goal": "appointment_phone_action",
                  href: `tel:${_setup.rawPhone}`,
                  "data-club-appointment-notice":
                    /* TODO: переписать с импортом компонента */ JSON.stringify(
                      {
                        isDirect:
                          !!_setup.selectedItem.workplace?.appointment_direct,
                        isClub: _vm.lpuAddress.tabs_data?.in_club,
                        price: _vm.lpuAddress.tabs_data?.club_price,
                        priceFull: _vm.lpuAddress.tabs_data?.price,
                        phoneNumber: _vm.lpuAddress.lpu.lpuphone.phone,
                        country: _vm.lpuAddress.lpu.town.region.country,
                        appointmentLink: `${_setup.urls?.createAppointmentForm}?doctor=${_setup.doctor?.id}&type=club&lpu=${_vm.lpuAddress.lpu.id}`,
                      }
                    ),
                },
              },
              [
                _c(
                  VIcon,
                  {
                    staticClass: "mr-4",
                    attrs: { size: "20", color: "icon-secondary" },
                  },
                  [_vm._v("\n      ui-icon-phone-call\n    ")]
                ),
                _vm._v("\n    " + _vm._s(_setup.formattedPhone) + "\n  "),
              ],
              1
            )
          : _vm.lpuAddress.lpu.is_show_registration_phone
          ? _c("div", [
              _c(
                "a",
                {
                  directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
                  staticClass:
                    "d-flex align-center text-decoration-none text-body-1 primary--text py-2 mt-2",
                  attrs: { href: `tel:${_setup.rawPhone}` },
                },
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "mr-4",
                      attrs: { size: "20", color: "icon-secondary" },
                    },
                    [_vm._v("\n        ui-icon-phone-call\n      ")]
                  ),
                  _vm._v("\n      " + _vm._s(_setup.formattedPhone) + "\n    "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "d-flex align-center text-body-1 py-2 mt-2" },
                [
                  _c(
                    VIcon,
                    {
                      staticClass: "mr-4",
                      attrs: { size: "20", color: "icon-secondary" },
                    },
                    [_vm._v("\n        ui-icon-wallet\n      ")]
                  ),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _setup.t("По ОМС приём бесплатный", _setup.options)
                      ) +
                      "\n    "
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ])
    : _c("div", [
        (_vm.lpuAddress.show_phone && _vm.lpuAddress.lpu.lpuphone?.phone) ||
        _vm.lpuAddress.lpu.is_show_registration_phone
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex align-center text-decoration-none text-body-1 py-2 mt-2",
              },
              [
                _c(
                  VIcon,
                  {
                    staticClass: "mr-4",
                    attrs: { size: "20", color: "icon-secondary" },
                  },
                  [_vm._v("\n      ui-icon-phone-call\n    ")]
                ),
                _vm._v("\n    " + _vm._s(_setup.formattedPhone) + "\n  "),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.lpuAddress.lpu.is_show_registration_phone
          ? _c(
              "div",
              { staticClass: "d-flex align-center text-body-1 py-2 mt-2" },
              [
                _c(
                  VIcon,
                  {
                    staticClass: "mr-4",
                    attrs: { size: "20", color: "icon-secondary" },
                  },
                  [_vm._v("\n      ui-icon-wallet\n    ")]
                ),
                _vm._v(
                  "\n    " +
                    _vm._s(
                      _setup.t("По ОМС приём бесплатный", _setup.options)
                    ) +
                    "\n  "
                ),
              ],
              1
            )
          : _vm._e(),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }